import React, { useState } from "react";
import { Row, Col } from "react-bootstrap"
import axiosService from "../../../utils/axios.service";
import { Table, Button } from 'antd';
import Loading from "../../customer/Loading";

import 'antd/dist/antd.min.css'

import "../scss/report.scss"

const ViewDetailSaleTvvCtmByDay = (props) => {
    const [showLoading, setShowLoading] = useState(false)
    const [pageSize, setPageSize] = useState(10)

    function convertCurrency(data) {
        let res = new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(data)
        return res;
    };
   

    const columns = [
        {
            title: 'Ngày thanh toán',
            dataIndex: 'date',
            // align: "center",
            fixed : 'left',
            width: 100,
            render: (data) => {
                return (
                    <p className="text4">{data}</p>
                )
            },
        },
        {
            title: 'Tổng số đơn hàng mới',
            dataIndex: 'countSaleTvv',
            // align: "center",
            width: 100,
            render: (data) => {
                return (
                    <p className="">{data}</p>
                )
            },
        },
        {
            title: 'Tổng tiền đã thu',
            dataIndex: 'paid',
            align: "center",
            width: 100,
            render: (data) => {
                return (
                    <p className="text1">{convertCurrency(Number(data))}</p>
                )
            },
        },
        {
            title: 'Tổng tiền thực thu bán hàng',
            dataIndex: 'paidNoTax',
            align: "center",
            width: 100,
            render: (data) => {
                return (
                    <p className="text1">{convertCurrency(Number(data))}</p>
                )
            },
        },
    ];
    const handelExportUser = () => {

    }
    const  handleChange = (e) => {
        setPageSize(e.pageSize)
    }

    return (
        <>
            <div style={{ backgroundColor: "white" }} className="p-2">
                <div className="border-bottom w-100 pb-2">
                    <Row>
                        <Col xs={6}>
                            <div>
                                Bảng số liệu chi tiết
                            </div>
                        </Col>
                        <Col xs={6}>
                            {/* <Button size="middle" type="primary"
                            onClick={handelExportUser}
                            ><i className="fa-solid fa-file-excel mr-2"></i>Xuất dữ liệu
                            </Button> */}
                        </Col>
                    </Row>
                </div>
                <Table 
                    columns={columns} 
                    dataSource={props.table}
                    pagination={{ pageSize: pageSize, showSizeChanger: true, pageSizeOptions: ['10', '15', '30', '50', '100'] }}
                    scroll={{ x: columns.length*200, y: 600 }}
                    onChange={handleChange}
                    bordered
                    rowKey="key"
                />
            </div>
            <Loading
            show={showLoading}
             ></Loading>
        </>
    )
}
export default ViewDetailSaleTvvCtmByDay